var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRamiUsoHiloPasticosGeneralesCeleste(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 406.6 50",
    style: {
      enableBackground: "new 0 0 406.6 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#74C0EB;}\n\t.st2{opacity:0.9;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.2,19.1c0.7,0.7,1.7,1.1,3,1.1c1.3,0,2.2-0.4,3-1.1c0.7-0.7,1.1-1.7,1.1-2.9V6.8h3.2v9.3 c0,1.4-0.3,2.6-0.9,3.6c-0.6,1-1.4,1.8-2.5,2.3c-1.1,0.5-2.4,0.8-3.8,0.8c-1.5,0-2.8-0.3-3.9-0.8s-1.9-1.3-2.5-2.3 c-0.6-1-0.9-2.2-0.9-3.6V6.8h3.2v9.3C136.1,17.4,136.4,18.4,137.2,19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159,9.8c-0.9-0.3-1.7-0.4-2.4-0.4c-0.8,0-1.4,0.1-1.8,0.4c-0.4,0.3-0.7,0.6-0.7,1.1c0,0.4,0.2,0.8,0.5,1.1 c0.3,0.3,0.7,0.5,1.2,0.7c0.5,0.2,1.1,0.4,1.9,0.6c1.1,0.3,2.1,0.6,2.8,1c0.7,0.3,1.3,0.8,1.8,1.4s0.8,1.4,0.8,2.4 c0,1-0.3,1.8-0.8,2.5s-1.3,1.3-2.3,1.6c-1,0.4-2.1,0.6-3.3,0.6c-1.3,0-2.6-0.2-3.8-0.7c-1.2-0.5-2.3-1.1-3.2-1.8l1.3-2.6 c0.8,0.7,1.8,1.3,2.8,1.7s2,0.6,2.9,0.6c0.9,0,1.6-0.2,2.1-0.5c0.5-0.3,0.8-0.8,0.8-1.3c0-0.5-0.2-0.8-0.5-1.1 c-0.3-0.3-0.7-0.5-1.2-0.7c-0.5-0.2-1.1-0.4-2-0.6c-1.1-0.3-2-0.6-2.8-0.9c-0.7-0.3-1.3-0.8-1.8-1.4c-0.5-0.6-0.8-1.4-0.8-2.4 c0-0.9,0.3-1.7,0.8-2.4c0.5-0.7,1.2-1.2,2.2-1.6c0.9-0.4,2-0.6,3.3-0.6c1.1,0,2.1,0.2,3.2,0.5c1.1,0.3,2,0.7,2.8,1.2l-1.3,2.7 C160.8,10.4,159.9,10,159,9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.2,7.7c1.4,0.7,2.4,1.7,3.2,2.9c0.8,1.2,1.2,2.6,1.2,4.1s-0.4,2.9-1.2,4.1c-0.8,1.2-1.8,2.2-3.2,3 c-1.4,0.7-2.9,1.1-4.5,1.1c-1.7,0-3.2-0.4-4.5-1.1c-1.4-0.7-2.4-1.7-3.2-3c-0.8-1.2-1.2-2.6-1.2-4.1s0.4-2.9,1.2-4.1 c0.8-1.2,1.8-2.2,3.2-2.9s2.9-1.1,4.5-1.1C175.3,6.6,176.8,7,178.2,7.7z M170.9,10.1c-0.9,0.5-1.6,1.1-2.1,1.9 c-0.5,0.8-0.8,1.7-0.8,2.7s0.3,1.9,0.8,2.7s1.2,1.5,2.1,2c0.9,0.5,1.8,0.7,2.8,0.7c1,0,1.9-0.2,2.8-0.7c0.9-0.5,1.5-1.1,2-2 s0.8-1.7,0.8-2.7s-0.2-1.9-0.8-2.7s-1.2-1.5-2-1.9s-1.8-0.7-2.8-0.7C172.7,9.4,171.8,9.6,170.9,10.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.5,36.9h2.8v6c-0.9,0.6-1.9,1.1-3.1,1.5c-1.2,0.4-2.4,0.6-3.5,0.6c-1.6,0-3.1-0.4-4.5-1.1 c-1.3-0.7-2.4-1.7-3.2-3c-0.8-1.2-1.2-2.6-1.2-4.1c0-1.5,0.4-2.9,1.2-4.1c0.8-1.2,1.9-2.2,3.2-2.9c1.4-0.7,2.9-1.1,4.6-1.1 c1.2,0,2.4,0.2,3.5,0.6c1.2,0.4,2.2,1,3,1.7l-1.8,2.2c-0.6-0.6-1.4-1-2.2-1.3c-0.8-0.3-1.7-0.5-2.5-0.5c-1,0-2,0.2-2.9,0.7 c-0.9,0.5-1.6,1.1-2.1,2c-0.5,0.8-0.8,1.7-0.8,2.7c0,1,0.3,1.9,0.8,2.7c0.5,0.8,1.2,1.5,2.1,2c0.9,0.5,1.8,0.7,2.9,0.7 c0.6,0,1.2-0.1,1.8-0.3c0.6-0.2,1.2-0.4,1.8-0.7V36.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151,28.9h12.2v2.7h-9v3.9h8.1v2.7h-8.1v4h9.3v2.7H151V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.3,28.9h3.1v15.9h-3l-8.6-10.9v10.9h-3.1V28.9h3l8.6,10.9V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.5,28.9h12.2v2.7h-9v3.9h8.1v2.7h-8.1v4h9.3v2.7h-12.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.7,44.8l-2.9-4.7c-0.1,0-0.3,0-0.6,0h-3.8v4.7h-3.2V28.9h7c2.2,0,3.8,0.5,5,1.4s1.8,2.3,1.8,4 c0,1.2-0.3,2.3-0.8,3.2c-0.6,0.9-1.4,1.5-2.5,2l3.7,5.3H211.7z M204.4,37.5h3.8c1.2,0,2.1-0.2,2.8-0.7c0.6-0.5,1-1.2,1-2.2 c0-1-0.3-1.7-1-2.2c-0.6-0.5-1.6-0.7-2.8-0.7h-3.8V37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230.8,44.8l-1.5-3.4h-8.1l-1.5,3.4h-3.3l7.3-15.9h3.3l7.2,15.9H230.8z M222.3,38.8h5.9l-2.9-6.7L222.3,38.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.2,28.9h3.2v13.1h7.2v2.7h-10.4V28.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "29,36.7 34.5,43.9 44.1,30.7 51.5,30.7 51.5,5.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.2,
    y: 5.7,
    className: "st1",
    width: 8.8,
    height: 38.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 5.7,
    className: "st1",
    width: 8.8,
    height: 38.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "76.4,44.4 67.6,44.4 67.6,11.5 76.5,20.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "94.1,44.4 102.9,44.4 102.9,11.5 94.2,20.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "67.6,5.7 77.4,5.7 85.1,15.4 93.4,5.6 102.9,5.7 102.9,9.1 85.1,27 67.6,9.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.9,15l22.3,29.1H21.8L1.9,18.6v-13h18.5c0,0,9.9,0.5,10.9,12.5c0,0,0.6,8.9-6.8,12.3l-6.4-8.2 c0,0,3.5,0.6,3.5-3.5c0,0,0-3.6-3.3-3.7L10.9,15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1.9,20.6 10.9,32.1 10.9,44.2 1.9,44.2  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1.9,20.9 10.9,32.5 11,44.5 2,44.5  "
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRamiUsoHiloPasticosGeneralesCeleste);
export default __webpack_public_path__ + "static/media/rami-uso-hilo-pasticos-generales-celeste.82aa1def7a81c2850aa7614ae57266d3.svg";
export { ForwardRef as ReactComponent };